var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RNavShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,17 C15,12.6 18.6,9 23,9 L25,9 C29.4,9 33,12.6 33,17 L33,19 L37,19 C38.1,19 39,19.9 39,21 L39,35 C39,37.2 37.2,39 35,39 L13,39 C10.8,39 9,37.2 9,35 L9,21 C9,19.9 9.9,19 11,19 L15,19 Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18,17 C18,14.3 20.3,12 23,12 L25,12 C27.7,12 30,14.3 30,17 L30,19 L18,19 Z",
    fill: "#0D0D12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20,25 L29.8,25 L28.4,28 L21.4,28 Z",
    fill: "#FFD000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17,30 C19.7,29.1 22.3,28.8 24.9,29.1 C27.1,29.4 29.2,30.1 31.3,31.5 L29.8,33.6 C28,32.6 26.1,32.1 24.3,31.9 C22.1,31.8 19.9,32.1 17.7,32.9 Z",
    fill: "#7C1CFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5,23.5 A1.9,1.9 0,1 0,32.5,27.3 A1.9,1.9 0,1 0,32.5,23.5",
    fill: "#00D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RNavShop);
export default __webpack_public_path__ + "static/media/p4r_nav_shop.d5eea267f18f7b602a5a22a4711854f0.svg";
export { ForwardRef as ReactComponent };